import React, { Component, Fragment } from 'react';
import indonesianProjects from "../../rawDatas/list-proyek-8-Juli-2023.json";
import englishProjects from "../../rawDatas/list-proyek-8-Juli-2023-eng.json";


export default class ProjectTables extends Component {
    constructor(props) {
        super(props);

        this.state = {
            projects : this.props.language === "en"? englishProjects : indonesianProjects
        }
    }

    render() {
        return (
            <Fragment>
                {this.state.projects.map((data) => {
                    return (
                        <div className='table-responsive'>
                            <table className=' table-bordered table-hover table'>
                                <colgroup>
                                    <col span="1" style={{width: "70%"}} />
                                    <col span="1" style={{width: "30%"}} />
                                </colgroup>
                                <thead>
                                    <tr className='info'>
                                        <th>{data.title}</th>
                                        <th>Area</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.projects.map((project) => {
                                        return (
                                            <tr>
                                                <td>{project.name}</td>
                                                <td>{project.area}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </Fragment>
        );
    }
}